var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.payslipcondition")) +
                " > " +
                _vm._s(_vm.$t("sidebar.all")) +
                "\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("base-table", {
            attrs: { pagination: _vm.pagination },
            on: { onPageChange: _vm.handlePageChange },
            scopedSlots: _vm._u([
              {
                key: "thead",
                fn: function() {
                  return [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("apps.payroll.message.name")))
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { width: "20%" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("apps.payroll.message.conditiontype"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { width: "20%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("apps.payroll.message.calculationtype")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "14%" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("apps.payroll.label.autoapplyshort")
                              )
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "tbody",
                fn: function() {
                  return [
                    _c(
                      "tbody",
                      [
                        _c("tr", [
                          _vm.empty
                            ? _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "4" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("message.notfounddata")) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.data, function(item, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "PaySlipConditionEdit",
                                        query: {
                                          id: item.conditionId,
                                          name: item.name
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.name) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      _vm.PAYSLIP_CONDITION_TRANSLATE[item.type]
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.isIncrement
                                      ? _vm.$t("apps.payroll.message.increment")
                                      : _vm.$t("apps.payroll.message.decrement")
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              item.autoApplyNewEmp
                                ? _c("i", { staticClass: "fas fa-check" })
                                : _vm._e()
                            ])
                          ])
                        })
                      ],
                      2
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10a61139", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a61139","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/payroll/condition/List.vue
// module id = null
// module chunks = 